<template>
  <section>
    <el-row>
      <el-col :span="6">
        <el-input placeholder="Please input Search Words" v-model="searchKey" prefix-icon="el-icon-fa-search">
          <div slot="append">
            <el-button type="primary" icon="el-icon-fa-search"
                       @click=" pager.pager.pageNumber = 1 ;doSearch()"></el-button>
          </div>
        </el-input>
      </el-col>

      <el-col :span="3" >
        <el-date-picker v-model="delbegin" type="date" placeholder="ETD" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">

        </el-date-picker>

      </el-col>
      <el-col :span="3" >
        <el-date-picker v-model="delend" type="date" placeholder="ETA" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-col>

    </el-row>

    <el-table :data="pager.dataList" border stripe style="width: 100%">
      <el-table-column prop="RefNo" label="Ref.No." width="120" show-overflow-tooltip head-align="center" align="center"></el-table-column>
      <el-table-column prop="OrderDelEnd" :formatter="formatRecdate" label="ORDER.ETD" width="120" show-overflow-tooltip head-align="center" align="center"></el-table-column>
      <el-table-column prop="OrderDelBegin" :formatter="formatRecdate" label="ORDER.ETA" width="120"  show-overflow-tooltip head-align="center" align="center"></el-table-column>
      <el-table-column prop="cCName" label="Name" head-align="center" align="center"></el-table-column>
      <el-table-column prop="Color" label="Color" head-align="center" align="center" width="150"></el-table-column>
      <el-table-column prop="Spec1" label="Spec1" head-align="center" align="center" width="180"></el-table-column>
      <el-table-column prop="Unit" label="Unit" head-align="center" align="center" width="60"></el-table-column>
      <el-table-column prop="QtyOrder" label="Order.Qty." head-align="center" align="center" width="100"></el-table-column>
      <el-table-column prop="cCompanyNameAcc" label="Supplier" head-align="center" align="center" width="100"></el-table-column>
    </el-table>
    <el-row>
      <el-col :span="6" :offset="18">
        <el-pagination background small style="float:right" layout="prev, pager, next"
                       :total="pager.pager.recordCount" :page-size="pager.pager.pageSize"
                       :current-page.sync="pager.pager.pageNumber" v-show="pager.pager.pageCount != 0"
                       @current-change="changePage">
        </el-pagination>
      </el-col>
    </el-row>


  </section>

</template>
<style>
  .el-form-item {
    margin-bottom: 0;
  }
  .el-table .cell.el-tooltip {
    white-space: pre-wrap;
    max-lines: 2;
  }
</style>

<script>
  import ElCol from "element-ui/packages/col/src/col";
  export default {
    components: {ElCol},
    data() {
      return {
        searchKey: "",
        pager: {
          pager: {
            pageCount: 0,
            pageNumber: 1,
            pageSize: 15,
            recordCount: 0
          }
        },
        ShipDetail: "Ship Detail",
        selected: [],
        details: [],
        delbegin:"",
        delend:"",
        addEditShow: false,
        grantShow: false,
        formLabelWidth: "120px",
      };
    },
    computed: {
      dialogWidth() {
        return 590 * 100 / this.$utils.windowWidth() + "%";
      }
    },
    watch: {
      options: function () {
        this.selected = [];
        this.options.forEach(item => {
          if (item.selected) {
            this.selected.push(item.key);
          }
        });
      }
    },
    methods: {
      changePage() {
        if (this.searchKey) {
          this.doSearch();
        } else {
          this.loadData();
        }
      },
      doSearch() {

        let searchs = this.searchKey
        if(this.delbegin != null && this.delbegin.length > 0)
          searchs = searchs+"#"+this.delbegin
        if(this.delend != null && this.delend.length > 0)
          searchs = searchs +"#"+this.delend
        this.$api.ShipFabNot.search(
          this.pager.pager.pageNumber,
          searchs,
          result => {
            this.pager = result.pager;

          }
        );


      },
      formatRecdate(row ,column){
        if(row[column.property] === "" || row[column.property] == null){

          return "";
        }else{

          return  row[column.property].substr(0,10);
        }
      },
      loadData() {
        this.$api.ShipFabNot.list(this.pager.pager.pageNumber, result => {
          this.pager = result.pager;
        });
      }
    },
    created: function () {
      this.loadData();
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/shipping/ShipFabNot.vue